import VersionNotification from './VersionNotification';

export default VersionNotification;
